import { render, staticRenderFns } from "./forgotPasswordCompleted.vue?vue&type=template&id=9b530d32&"
import script from "./forgotPasswordCompleted.vue?vue&type=script&lang=ts&"
export * from "./forgotPasswordCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports